import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchCalendariosLaborales = async (anio = null) => {
    try {
        const params = { _t: Date.now() };
        if (anio) params.anio = anio;

        const response = await axios.get(`${API_URL}/api/calendarios-laborales`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`,
                'Cache-Control': 'no-cache'
            },
            params
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchCalendarioLaboral = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/api/calendarios-laborales/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const crearCalendarioLaboral = async (data) => {
    try {
        const response = await axios.post(`${API_URL}/api/calendarios-laborales`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const actualizarCalendarioLaboral = async (id, data) => {
    try {
        const response = await axios.put(`${API_URL}/api/calendarios-laborales/${id}`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const eliminarCalendarioLaboral = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/api/calendarios-laborales/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const duplicarCalendarioLaboral = async (id, nuevoAnio) => {
    try {
        const response = await axios.post(`${API_URL}/api/calendarios-laborales/${id}/duplicar`, { nuevoAnio }, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchVistaAnualCalendario = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/api/calendarios-laborales/${id}/vista-anual`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};
